import debug from "debug";

const log = debug("desjti:ui:formatDate:normalizeDate");
export const normalizeDate = (date: string | Date, treatAsLocalTime?: boolean): Date => {
  const shouldFormatDate = typeof date === "string" && !date.includes("T");
  const hasTime = typeof date === "string" && date.includes(":");

  if (!shouldFormatDate) {
    return typeof date === "string" ? new Date(date) : date;
  }

  if (hasTime && treatAsLocalTime) {
    const isoUtcString = date.replace(" ", "T");
    return new Date(isoUtcString);
  }
  const oldTime = new Date(date);
  const offset = -oldTime.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  const newTime = new Date(oldTime.getTime() - offset);
  log("normalizeDate", {
    valueObtained: date,
    valueDate: oldTime,
    normalizedValue: newTime,
    timezoneOffset: offset,
  });
  return newTime;
};
